import emBase from "@/store/em/emBase";
// import emWebsocket from "@/store/em/emWebsocket";

import manualIndexEmStores from "@/store/em/manual-index-em-stores";
import emStoresAdmin from "@/store/em/admin/moduleIndex-store-em-admin";
import emStoresLifecycle from "@/store/em/lifecycle/moduleIndex-store-em-lifecycle";
import emStoresArchive from "@/store/em/archive/moduleIndex-store-em-archive";
import emStoresWorkflow from "@/store/em/workflow/moduleIndex-store-em-workflow";
import emStoresInspection from "@/store/em/inspection/moduleIndex-store-em-inspection";
import emStoresRepair from "@/store/em/repair/moduleIndex-store-em-repair";
import emStoresMaintenance from "@/store/em/maintenance/moduleIndex-store-em-maintenance";
import emStoresSpp from "@/store/em/spareparts/moduleIndex-store-em-spareparts";
import emStoresAcct from "@/store/em/accident/moduleIndex-store-em-accident";
import emStoreOpcClient from "@/store/em/opcClient/moduleIndex-store-em-opcClient";
import emStoresSic from "@/store/em/statusCollection/moduleIndex-store-em-statusCollection";
import emStoresPpe from "@/store/em/ppe/moduleIndex-store-em-ppe";
import emStoresEpc from "@/store/em/epc/moduleIndex-store-em-epc";
import emStoresAsset from "@/store/em/asset/moduleIndex-store-em-asset";
const entities = {
    emBase,
    // emWebsocket,
    ...manualIndexEmStores,
    ...emStoresAdmin,
    ...emStoresLifecycle,
    ...emStoresArchive,
    ...emStoresWorkflow,
    ...emStoresInspection,
    ...emStoresRepair,
    ...emStoresMaintenance,
    ...emStoresSpp,
    ...emStoresAcct,
    ...emStoreOpcClient,
    ...emStoresSic,
    ...emStoresPpe,
    ...emStoresEpc,
    ...emStoresAsset
}

export default entities
